/**
 * @module Utils.File
 *
 */

/**
 * convert a data url to a blob
 *
 * @public
 * @method dataUrlToBlob
 * @param {string} base64
 * @param {string} type
 * @return {Blob}
 */
export default function dataUrlToBlob(
  base64: string,
  type: string = "image/jpeg",
) {
  if (!base64 || typeof base64 !== "string") {
    throw new Error("Invalid base64 input: Not a string");
  }

  const parts = base64.split(",");
  if (parts.length !== 2 || !parts[1]) {
    throw new Error("Invalid base64 input: Missing data URL header or data");
  }

  try {
    const binary = atob(parts[1]);
    const buffer = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      buffer[i] = binary.charCodeAt(i);
    }
    return new Blob([buffer], { type });
  } catch (err) {
    throw new Error("Invalid base64 input: Failed to decode");
  }
}
